import { render, staticRenderFns } from "./answerPanel.vue?vue&type=template&id=8a90af08&scoped=true&"
import script from "./answerPanel.vue?vue&type=script&lang=js&"
export * from "./answerPanel.vue?vue&type=script&lang=js&"
import style0 from "./answerPanel.vue?vue&type=style&index=0&id=8a90af08&scoped=true&lang=scss&"
import style1 from "./answerPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a90af08",
  null
  
)

export default component.exports